import React, { useState, KeyboardEvent } from "react";
import "./PageSearch.scss";
import { useTranslation, withTranslation } from "react-i18next";
import { isMobileMatcheState, searchState } from "../../../../../atoms/atom";
import { useRecoilValue, useRecoilState } from "recoil";

function PageSearch() {
  const { t } = useTranslation();
  const isMobil = useRecoilValue(isMobileMatcheState);
  const [isOpenSearch, setIsOpenSearch] = useState(false);
  const handleSearch = () => {
    setIsOpenSearch((prev) => !prev);
  };
  const [searchVal, setSearchVal] = useRecoilState(searchState);
  const getSearchVal = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchVal(e.currentTarget.value);
  };

  const maxLength = 20;
  return (
    <div className="search">
      {/* 기본 버전 */}
      {!isMobil && (
        <div className="open-search-bg">
          <label htmlFor="searchPage" className="hidden" />
          <input
            className="page-search"
            id="searchPage"
            type="text"
            maxLength={maxLength}
            placeholder={t("Enter_title_content")}
            value={searchVal}
            onChange={(e) => getSearchVal(e)}
          />
        </div>
      )}

      {/* 모바일 버전 */}
      {isMobil && (
        <>
          {isOpenSearch ? (
            <div className="open-search">
              <div className="open-search-bg">
                <label htmlFor="searchPage" className="hidden" />
                <input
                  className="page-search"
                  id="searchPage"
                  type="text"
                  maxLength={maxLength}
                  placeholder={t("Enter_title_content")}
                  value={searchVal}
                  onChange={(e) => getSearchVal(e)}
                />
              </div>
            </div>
          ) : null}
        </>
      )}
      <button
        className={isOpenSearch ? "page-search-btn on" : "page-search-btn"}
        onClick={handleSearch}
      />
    </div>
  );
}

export default withTranslation()(PageSearch);
